<app-header [class.g-high-contrast]="main.highContrast"></app-header>
<div class="side-bar-container" [class.expanded]="main.menuExpanded" [class.g-high-contrast]="main.highContrast">
  <div *ngIf="authService.loggedIn() && !authService.isAwaiting2FA()" class="side-bar">
    <app-nav></app-nav>
  </div>
  <div id="gap" class="side-bar-content" [ngClass]="router.url.substr(1)" (click)="main.menuExpanded = false">
    <router-outlet></router-outlet>
  </div>
</div>
